import { Injectable } from "@angular/core";
import { noop } from "lodash";
import { PrimeIcons, MessageService as PrimeNGMessageService, type ToastMessageOptions } from "primeng/api";
import { Observable } from "rxjs";
import { SettingsService } from "../../shared/services/settings.service";
import { Message, MessageService, SpecialMessageKey } from "./message.service";

@Injectable({ providedIn: "root" })
export class NewUiMessageService implements MessageService {
  private readonly NewUiSeverities: Record<Message["severity"], ToastMessageOptions["severity"]> = {
    success: "success",
    info: "info",
    warning: "warn",
    error: "error",
  };

  private readonly NewUiSeverityIcons: Record<Message["severity"], ToastMessageOptions["icon"]> = {
    success: PrimeIcons.CHECK,
    info: PrimeIcons.INFO_CIRCLE,
    warning: PrimeIcons.QUESTION_CIRCLE,
    error: PrimeIcons.EXCLAMATION_TRIANGLE,
  };

  private readonly NewUiSpecialMessageKeyProps: Record<SpecialMessageKey, { sticky: boolean; closable: boolean }> = {
    "translation-proposal": { sticky: true, closable: false },
    "candidate-field-diff": { sticky: true, closable: false },
  };

  readonly message$: Observable<Message> = null;

  constructor(
    private readonly settings: SettingsService,
    private readonly messageService: PrimeNGMessageService
  ) {}

  add(message: Message): void {
    const problemSeverities: Message["severity"][] = ["warning", "error"];
    if (this.settings.hideErrorOverlays && problemSeverities.includes(message.severity)) {
      return;
    }

    this.messageService.add({
      severity: this.NewUiSeverities[message.severity],
      icon: this.NewUiSeverityIcons[message.severity],
      summary: message.summary,
      detail: message.detail,
      key: message.key,
      sticky: message.key ? this.NewUiSpecialMessageKeyProps[message.key].sticky : undefined,
      closable: message.key ? this.NewUiSpecialMessageKeyProps[message.key].closable : undefined,
    });
  }

  clear(key: SpecialMessageKey): void {
    this.messageService.clear(key);
  }

  pause(): void {
    noop();
  }

  resume(): void {
    noop();
  }
}
